import { useEffect } from 'react';
import { userAgentUtils } from '../utils/userAgentUtility';
import { BackToTownButton } from './BackToTownButton';

const { isMobile } = userAgentUtils();

export const MobileBlock = () => {
  const disableEvents = (event: Event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('keydown', disableEvents, true);

      return () => {
        document.removeEventListener('keydown', disableEvents, true);
      };
    }
  }, []);

  if (!isMobile) {
    return null;
  }

  return (
    <>
      <div className={`z-[90] block fixed inset-0 bg-black bg-opacity-50`}></div>
      <div
        className={`z-[100] absolute w-[90%] h-fit m-auto top-0 left-0 bottom-0 right-0 flex items-center justify-center bg-white border-current_key border-4 py-16 rounded-2xl`}
      >
        <div className="flex flex-col gap-24 items-center w-auto rounded-2xl font-bold text-5xl ">
          <p className="text-sub_text">パソコンでチャレンジしてね</p>
          <BackToTownButton buttonType="square" />
        </div>
      </div>
    </>
  );
};
